import Button from 'ui/Button';
import Dialog from 'ui/Dialog';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  discardChanges: () => void;
};

const UnsavedChangesAlertDialog: React.FC<Props> = ({
  open,
  setOpen,
  discardChanges,
}) => (
  <Dialog.Root
    open={open}
    onOpenChange={(e) => setOpen(e.open)}
    role="alertdialog"
  >
    <Dialog.Content>
      <Dialog.Header>Unsaved changes</Dialog.Header>
      <Dialog.Body>
        You have unsaved changes. Are you sure you want to leave?
      </Dialog.Body>
      <Dialog.Footer>
        <Button variant="danger-ghost" onClick={discardChanges}>
          Discard changes
        </Button>
        <Button variant="primary-solid" onClick={() => setOpen(false)}>
          Continue editing
        </Button>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>
);

export default UnsavedChangesAlertDialog;
